/**
 * Indicates whether the rate source specified is a primary or secondary source.
 * tag: 1447
 * @readonly
 * @enum {number} (int)
 */
export enum RateSourceType {
  /** Primary */
  Primary = 0,
  /** Secondary */
  Secondary = 1,
}
